export default __webpack_public_path__ + "static/media/cert-it-consumer.2aa9a6ea.jpg";